import { Course, PlayerResult, TeamGameMatch, TeamGameMatchTeam, TeamGamePlayerDisplay } from '../../database.schema';
import { BACK_NINE_INDEX, FRONT_NINE_INDEX, MATCH_FORMATS } from '../app/constants';
import { calculateScore, getPlayerScore } from './score-calculator';

export const getHoleTierPoints6_6_6 = (players: Array<TeamGamePlayerDisplay> | Array<PlayerResult>, holeIndex: number, course: Course, startingHole: number) => {
  const scorecardHoleOrder = startingHole === 1 ? [...FRONT_NINE_INDEX, ...BACK_NINE_INDEX] : [...BACK_NINE_INDEX, ...FRONT_NINE_INDEX];
  const playerScores = players
    .map((player) =>
      calculateScore({
        par: course.scoreCard[scorecardHoleOrder[holeIndex]],
        score: player.round.scoreCard[holeIndex],
        handicap: player.round.individualHandicap,
        strokeIndex: course.strokeIndex[scorecardHoleOrder[holeIndex]],
      }),
    )
    .sort()
    .reverse();
  if (holeIndex < 6) {
    const countingScores = playerScores.slice(0, playerScores.length - 2);
    return countingScores.reduce((acc, cur) => acc + cur, 0);
  }
  if (holeIndex > 5 && holeIndex < 12) {
    const countingScores = playerScores.slice(0, playerScores.length - 1);
    return countingScores.reduce((acc, cur) => acc + cur, 0);
  }
  return playerScores.reduce((acc, cur) => acc + cur, 0);
};

export const getHoleTierPoints1_2_3 = (players: Array<TeamGamePlayerDisplay> | Array<PlayerResult>, holeIndex: number, course: Course, startingHole: number) => {
  const scorecardHoleOrder = startingHole === 1 ? [...FRONT_NINE_INDEX, ...BACK_NINE_INDEX] : [...BACK_NINE_INDEX, ...FRONT_NINE_INDEX];
  const playerScores = players
    .map((player) =>
      calculateScore({
        par: course.scoreCard[scorecardHoleOrder[holeIndex]],
        score: player.round.scoreCard[holeIndex],
        handicap: player.round.individualHandicap,
        strokeIndex: course.strokeIndex[scorecardHoleOrder[holeIndex]],
      }),
    )
    .sort()
    .reverse();
  if (holeIndex === 0 || holeIndex === 3 || holeIndex === 6 || holeIndex === 9 || holeIndex === 12 || holeIndex === 15) {
    const countingScores = playerScores.slice(0, playerScores.length - 2);
    return countingScores.reduce((acc, cur) => acc + cur, 0);
  }
  if (holeIndex === 1 || holeIndex === 4 || holeIndex === 7 || holeIndex === 10 || holeIndex === 13 || holeIndex === 16) {
    const countingScores = playerScores.slice(0, playerScores.length - 1);
    return countingScores.reduce((acc, cur) => acc + cur, 0);
  }
  return playerScores.reduce((acc, cur) => acc + cur, 0);
};

export const getTierPoints6_6_6_TeamTotalPoints = (players: Array<PlayerResult>, course: Course, startingHole: number): number => {
  const zeroToSeventeenIndices = startingHole === 1 ? [...FRONT_NINE_INDEX, ...BACK_NINE_INDEX] : [...BACK_NINE_INDEX, ...FRONT_NINE_INDEX];
  return zeroToSeventeenIndices.reduce((acc, index) => acc + getHoleTierPoints6_6_6(players, index, course, startingHole), 0);
};

export const getPlayerStablefordPoints = (players: Array<PlayerResult>, course: Course, startingHole: number): Array<PlayerResult> => {
  return [
    ...players.map((player) => {
      player.points = getPlayerScore(player.round.individualHandicap, player.round.scoreCard, course, startingHole);
      return { ...player };
    }),
  ];
};
export const getTierPoints6_6_6_TeamTotals = (teams: Array<TeamGameMatchTeam>, course: Course, startingHole: number): Array<TeamGameMatchTeam> => {
  const newTeams = [...teams];

  newTeams.forEach((team: TeamGameMatchTeam, index) => {
    team.points = getTierPoints6_6_6_TeamTotalPoints(team.players, course, startingHole);
    team.players = getPlayerStablefordPoints(team.players, course, startingHole);
  });

  return newTeams;
};

const removeDuplicates = (value: number, index: number, array: Array<number>) => array.indexOf(value) === index;

type PointsTable = {
  points: number;
  teamsWithThesePoints: number;
};

export const getTeamGameMatchResultSortedOrder = (match: TeamGameMatch): TeamGameMatch => {
  if (match.matchFormat === MATCH_FORMATS.tierPoints_6_6_6.id || match.matchFormat === MATCH_FORMATS.tierPoints_1_2_3.id) {
    const sortedTotalPointsTable: Array<PointsTable> = match.teams
      .map((team) => team.points)
      .sort((a, b) => a - b)
      .reverse()
      .filter((teamPoints, index, points) => removeDuplicates(teamPoints, index, points))
      .map((points) => ({ points: points, teamsWithThesePoints: match.teams.filter((team) => team.points === points).length }));

    const teamsWithResult = match.teams.map((team) => {
      if (team.points === sortedTotalPointsTable[0].points) {
        if (sortedTotalPointsTable[0].teamsWithThesePoints === 1) {
          return { ...team, result: 'win' };
        } else {
          return { ...team, result: 'halved' };
        }
      } else {
        return { ...team, result: 'lost' };
      }
    });

    return { ...match, teams: [...teamsWithResult.sort((teamA, teamB) => teamB.points - teamA.points)] };
  }

  return match;
};
